import React, { useState, useContext, useEffect } from 'react';
import { Button, TextField, Grid, CircularProgress } from '@material-ui/core';
import { useRequest } from 'src/hooks';
import moment from 'moment';
import { JCdTransactionsContext } from 'src/views/trans/JCdTrans/useJCdTransContext';
import { useNotif } from 'src/hooks';
const Button_Display = ({ data = {}, onChangeField, maxLength = 255 }) => {
  const [textValue, setTextValue] = useState(value || '');
  const req = useRequest();
  const [loading, setLoading] = useState(false);
  const context = useContext(JCdTransactionsContext);
  const notif = useNotif();
  const {
    caption = '',
    value = '',
    component_settings = {},
    fld = '',
    editableValue = true
  } = data;

  const {
    buttonLabel = 'Click',
    buttonDisabled = false,
    buttonColor = 'primary',
    buttonVariant = 'contained',
    disabled = false,
    textFieldSize = 8,
    buttonSize = 4,
    ixRep,
    placeholder = '',
    filter,
    require_payload = false
  } = component_settings;
  // Initialize Data
  useEffect(() => {
    setTextValue(data?.value || '');
  }, []);

  const handleClick = async () => {
    if (!ixRep) return;

    const payload = {
      ixRep,
      dt1: moment().format(),
      dt2: moment().format(),
      ixProdCat: 0,
      ixWH: 0,
      ixProdCatSub: 0
    };

    const { transDetails = {}, kvs = {} } = context?.transactionsData || {};

    let valid = true;
    if (Array.isArray(filter)) {
      filter.forEach((data, index) => {
        const { key, type, payload_key } = data;
        const [source, key2] = key.split('.');

        let val;
        if (source === 'jv') {
          if (
            transDetails?.[key2].value !== '' &&
            transDetails?.[key2].value !== 0
          ) {
            val = transDetails?.[key2].value;
          }
        } else if (source === 'kvs') {
          if (kvs?.[key2].value !== '' && kvs?.[key2].value !== 0) {
            val = kvs?.[key2].value;
          }
        }
        if (val !== undefined) {
          switch (type) {
            case 'string':
              val = String(val);
              break;
            case 'numeric':
              val = Number(val);
              break;
          }

          payload[payload_key] = val;
        } else {
          if (require_payload) {
            valid = false;
            notif.error('Fields Missing');
          }
        }
      });
    }

    if (!valid) {
      return;
    }
    setLoading(true);

    try {
      const res = await req.post('/dashboard/customrep', payload);

      const newValue = res?.data?.data?.[0]?.result ?? ''; // <- adjust this
      setTextValue(newValue);
      onChangeField({
        target: {
          name: fld,
          value: newValue
        }
      });
    } catch (err) {
      console.error('❌ Request failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={textFieldSize}>
        <TextField
          fullWidth
          label={caption}
          value={textValue}
          name={fld}
          onChange={onChangeField}
          disabled={!editableValue || disabled}
          placeholder={placeholder}
          inputProps={{ maxLength }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={buttonSize}>
        <Button
          onClick={handleClick}
          disabled={buttonDisabled || loading}
          variant={buttonVariant}
          color={buttonColor}
          fullWidth
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            buttonLabel
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Button_Display;
